import { useSelector } from 'react-redux';

export const useUnderMaintenance = () => {
  const maintenanceReducer = useSelector(storeState => storeState.maintenance);
  const { underMaintenance, value } = maintenanceReducer || {};
  const { end_ts: maintenanceEndTsFromCF } = value || {};

  return {
    underMaintenance,
    maintenanceEndTsFromCF,
  };
};
